import React, { FC, useMemo, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { RTKResponse } from 'bus';

import { MONEY_FORMAT } from 'constants/formats';
import { Button } from 'devextreme-react';
import { onExporting } from 'utils/exportingExcel';
import { useConfirmDialog } from 'utils/hooks';

import { useDeleteCashFlowItemMutation } from 'bus/cash';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import $createStore from '../../../../utils/create-store-instance';

const CashFlowDeletedDocuments: FC = () => {
  const { getConfirmation } = useConfirmDialog();
  const refGrid = useRef<DataGrid | null>(null);

  const [deleteCashFlowItem] = useDeleteCashFlowItemMutation();

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/CashFlow/DeletedDocuments', 'id');
  }, []);
  const requestCashFlowDocumentKinds = useMemo(() => {
    return $createStore('/v1/CashFlow/cashFlowDocumentKinds', 'id');
  }, []);
  const requestCashFlowAccounts = useMemo(() => {
    return $createStore('/v1/CashFlow/cashFlowAccounts', 'id');
  }, []);
  const requestCashFlowItemTypes = useMemo(() => {
    return $createStore('/v1/cashFlow/cashFlowTypes', 'id');
  }, []);

  const refresh = () => {
    refGrid.current?.instance.refresh();
  };

  const reStoreDocument = async (id: number) => {
    const isConfirmed = await getConfirmation({
      title: 'Восстановление документа',
      message: 'Вы точно хотите восстановить документ?',
      textConfirmButton: 'Восстановить',
    });

    if (isConfirmed) {
      await deleteCashFlowItem({ id }).then(({ error }: RTKResponse) => !error && refresh());
    }
  };

  return (
    <div>
      <AppLayoutTop title="Удаленные документы" />

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onExporting={onExporting}
        >
          <Export enabled={true} />
          <StateStoring enabled={true} type="localStorage" storageKey="cashFlowDeletedDocuments" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={150} />
          <Column dataField="documentKind" caption="Вид документа">
            <Lookup dataSource={requestCashFlowDocumentKinds} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="cashFlowAccount" caption="Статья списания">
            <Lookup dataSource={requestCashFlowAccounts} valueExpr="id" displayExpr="name" />
          </Column>

          <Column dataField="cashFlowType" caption="Тип">
            <Lookup dataSource={requestCashFlowItemTypes} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="sum" caption="Сумма" format={MONEY_FORMAT} />
          <Column dataField="employeeName" caption="Имя сотрудника" />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            allowSearch={false}
            cellRender={(data) => (
              <>
                <Button
                  icon="pulldown"
                  type="default"
                  stylingMode="text"
                  onClick={() => reStoreDocument(data.data.id)}
                />
              </>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default CashFlowDeletedDocuments;
